import { render, staticRenderFns } from "./POCCodigoDeBarras.vue?vue&type=template&id=44c29d15&scoped=true"
import script from "./POCCodigoDeBarras.vue?vue&type=script&lang=js"
export * from "./POCCodigoDeBarras.vue?vue&type=script&lang=js"
import style0 from "./POCCodigoDeBarras.vue?vue&type=style&index=0&id=44c29d15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c29d15",
  null
  
)

export default component.exports